
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface PhaseInfoProps {
  phase: {
    phase: string;
    color: string;
    description: string;
  };
}

export const PhaseInfo = ({ phase }: PhaseInfoProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Phase actuelle</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div 
            className="p-4 rounded-lg"
            style={{ 
              backgroundColor: phase.color,
              color: '#FFFFFF',
              textShadow: '0px 1px 2px rgba(0, 0, 0, 0.2)'
            }}
          >
            <h3 className="font-semibold text-lg">{phase.phase}</h3>
            <p>{phase.description}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
